module.exports = __webpack_public_path__ + "static/media/cassi.824ff167.jpg";